import { P } from 'fractals'
import { TPhoneNumberProps } from '../../../types'

const PhoneNumber = ({ children }: TPhoneNumberProps) => (
  <P variant='eta'>{children}</P>
)
export default PhoneNumber
